import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';

export type ScheduleRange = 'today' | 'tomorrow' | 'this_week' | 'next_week';

// One job from api/dashboard/inspector-schedule (App\Http\Controllers\Api\InspectorDashboardController).
export interface ScheduledInspection {
    job_id: number;
    report_number: string;
    scheduled_at: string;      // ISO 8601 with the app timezone offset
    ends_at: string | null;
    anytime: boolean;
    completed: boolean;
    job_status: string;
    type: string;
    client: string;
    address1: string;
    address2: string;
    lat: number | null;
    lng: number | null;
}

export interface ScheduleResponse {
    range: ScheduleRange;
    from: string;
    to: string;
    now: string;
    inspections: ScheduledInspection[];
}

// The Notifications widget's data contract. The client will say what to raise ("1 report is
// overdue", ...) and how; until then the feed is empty and the widget shows its empty state.
export interface DashboardNotification {
    level: 'urgent' | 'warning' | 'info';
    title: string;
    detail: string;
    link?: string;             // Angular route or full URL
}

@Injectable({
    providedIn: 'root'
})
export class InspectorDashboardService {
    constructor(private http: HttpClient) { }

    schedule(range: ScheduleRange): Observable<ScheduleResponse> {
        return this.http.get<ScheduleResponse>(environment.api + 'dashboard/inspector-schedule', {
            params: new HttpParams().set('range', range)
        });
    }

    // Not wired yet — see DashboardNotification.
    notifications(): Observable<DashboardNotification[]> {
        return of([]);
    }
}
